<div class="tool-cards">
  @for (tool of tools; track tool.id) {
    <button type="button" class="tool-card" aria-haspopup="dialog" (click)="open(tool, $any($event.currentTarget))">
      <span class="tool-card-top">
        <span class="tool-icon" aria-hidden="true">
          @switch (tool.id) {
            @case ('json') {
              <svg viewBox="0 0 24 24" focusable="false">
                <path d="M8 3.5c-2 0-3 1-3 3v2.5c0 1.5-.8 2.5-2.2 3 1.4.5 2.2 1.5 2.2 3v2.5c0 2 1 3 3 3" />
                <path d="M16 3.5c2 0 3 1 3 3v2.5c0 1.5.8 2.5 2.2 3-1.4.5-2.2 1.5-2.2 3v2.5c0 2-1 3-3 3" />
              </svg>
            }
            @case ('jwt') {
              <svg viewBox="0 0 24 24" focusable="false">
                <circle cx="7.5" cy="15.5" r="4" />
                <path d="M10.4 12.6 20 3M16.5 6.5l3 3M13.5 9.5l2 2" />
              </svg>
            }
            @case ('sql') {
              <svg viewBox="0 0 24 24" focusable="false">
                <ellipse cx="12" cy="5.5" rx="7.5" ry="2.8" />
                <path d="M4.5 5.5v13c0 1.5 3.4 2.8 7.5 2.8s7.5-1.3 7.5-2.8v-13M4.5 12c0 1.5 3.4 2.8 7.5 2.8s7.5-1.3 7.5-2.8" />
              </svg>
            }
            @case ('regex') {
              <svg viewBox="0 0 24 24" focusable="false">
                <path d="M16.5 3v10M12.2 5.5l8.6 5M12.2 10.5l8.6-5" />
                <circle cx="6.5" cy="17.5" r="2.5" />
              </svg>
            }
            @case ('api') {
              <svg viewBox="0 0 24 24" focusable="false">
                <path d="M21 3 10.5 13.5M21 3l-6.5 18-4-7.5L3 9.5 21 3Z" />
              </svg>
            }
          }
        </span>
        <span class="tool-tag">{{ tool.tag }}</span>
      </span>
      <span class="tool-title">{{ tool.title }}</span>
      <span class="tool-desc">{{ tool.description }}</span>
      <span class="tool-open">Open tool <span class="tool-arrow" aria-hidden="true">→</span></span>
    </button>
  }
</div>

<div class="modal" [class.is-open]="isOpen()" [class.is-fullscreen]="isFullscreen()" (keydown)="onKeydown($event)">
  <div class="modal-backdrop" (click)="close()"></div>
  <div #panel class="modal-panel" role="dialog" aria-modal="true" aria-labelledby="tool-modal-title" tabindex="-1">
    @if (active(); as tool) {
      <header class="modal-head">
        <div>
          <span class="tool-tag">{{ tool.tag }} · runs in your browser</span>
          <h3 id="tool-modal-title">{{ tool.title }}</h3>
        </div>
        <div class="modal-actions">
          <button
            type="button"
            class="modal-icon-btn"
            (click)="isFullscreen.set(!isFullscreen())"
            [attr.aria-pressed]="isFullscreen()"
            [attr.aria-label]="isFullscreen() ? 'Exit full screen' : 'Full screen'"
            [title]="isFullscreen() ? 'Exit full screen' : 'Full screen'"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              @if (isFullscreen()) {
                <path d="M9 4v5H4M15 4v5h5M9 20v-5H4M15 20v-5h5" />
              } @else {
                <path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" />
              }
            </svg>
          </button>
          <button type="button" class="modal-icon-btn modal-close" (click)="close()" aria-label="Close {{ tool.title }}" title="Close">
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18" /></svg>
          </button>
        </div>
      </header>
      <div class="modal-body">
        @switch (tool.id) {
          @case ('json') {
            @defer (on immediate) { <app-json-formatter /> } @loading { <p class="modal-loading">Loading tool…</p> } @error { <ng-container [ngTemplateOutlet]="loadError" /> }
          }
          @case ('jwt') {
            @defer (on immediate) { <app-jwt-decoder /> } @loading { <p class="modal-loading">Loading tool…</p> } @error { <ng-container [ngTemplateOutlet]="loadError" /> }
          }
          @case ('sql') {
            @defer (on immediate) { <app-sql-formatter /> } @loading { <p class="modal-loading">Loading tool…</p> } @error { <ng-container [ngTemplateOutlet]="loadError" /> }
          }
          @case ('regex') {
            @defer (on immediate) { <app-regex-tester /> } @loading { <p class="modal-loading">Loading tool…</p> } @error { <ng-container [ngTemplateOutlet]="loadError" /> }
          }
          @case ('api') {
            @defer (on immediate) { <app-api-tester /> } @loading { <p class="modal-loading">Loading tool…</p> } @error { <ng-container [ngTemplateOutlet]="loadError" /> }
          }
        }
      </div>
    }
  </div>
</div>

<ng-template #loadError>
  <div class="modal-loading" role="alert">
    <p>This tool couldn’t be loaded. That usually means the site was updated while this page was open, or the connection dropped.</p>
    <button type="button" class="modal-retry" (click)="reloadPage()">Reload page</button>
  </div>
</ng-template>
